import React from 'react';

import PropTypes from 'prop-types';

const TableWrapper = ({ children }) => {
    return (
        <div className="bg-white p-8 dark:bg-icoDarkMode-anthracite sm:rounded-lg">{children}</div>
    );
};

TableWrapper.propTypes = {
    children: PropTypes.node
};

export default TableWrapper;
